import type {
  ReploElement,
  ReploPartialElement,
} from "schemas/generated/element";

export function isElementPartial(
  value: ReploPartialElement | ReploElement | null,
): value is ReploPartialElement {
  if (!value) {
    return false;
  }
  return !("id" in value);
}
